import { render, staticRenderFns } from "./RemoteTeam.vue?vue&type=template&id=07a56b57&scoped=true&"
import script from "./RemoteTeam.vue?vue&type=script&lang=js&"
export * from "./RemoteTeam.vue?vue&type=script&lang=js&"
import style0 from "./RemoteTeam.vue?vue&type=style&index=0&id=07a56b57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a56b57",
  null
  
)

export default component.exports